import { render, staticRenderFns } from "./AlertsKpi.vue?vue&type=template&id=72375449&scoped=true"
import script from "./AlertsKpi.vue?vue&type=script&lang=js"
export * from "./AlertsKpi.vue?vue&type=script&lang=js"
import style0 from "./AlertsKpi.vue?vue&type=style&index=0&id=72375449&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72375449",
  null
  
)

export default component.exports